export default __webpack_public_path__ + "static/media/saint_aubin16.e5d29e1c.jpg";